import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TippyDirective } from '../../directives/tippy.directive';
import TOOLTIP_KEYS from '../../constants/tooltips';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule, TippyDirective],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  readonly TOOLTIP_KEYS = TOOLTIP_KEYS;
}
